import React from 'react';

/**
 * Quick period filter — 30 days / 90 days / 12 months / all-time.
 * Used on Devis and Factures tables. Selecting a period filters the rows by
 * `dateField` AND the surrounding KPI cards recompute from the filtered set
 * (the page's own logic must read `period` and reduce KPIs locally).
 *
 * Vague 99.4 — same component reused on Devis + Factures + future tables.
 */
const PERIODS = [
  { id: '30d', label: '30 jours', days: 30 },
  { id: '90d', label: '90 jours', days: 90 },
  { id: '12m', label: '12 mois', days: 365 },
  { id: 'all', label: 'Tout', days: null },
];

export function periodCutoffDate(periodId) {
  const p = PERIODS.find((x) => x.id === periodId);
  if (!p || !p.days) return null;
  const d = new Date();
  d.setDate(d.getDate() - p.days);
  return d.toISOString().slice(0, 10); // YYYY-MM-DD
}

export default function PeriodFilter({ value, onChange, testId = 'period-filter' }) {
  return (
    <div
      data-testid={testId}
      className="inline-flex items-center bg-[#EEF2FF] rounded-lg p-0.5 gap-0.5"
      role="tablist"
      aria-label="Filtre rapide par période"
    >
      {PERIODS.map((p) => {
        const active = value === p.id;
        return (
          <button
            key={p.id}
            type="button"
            role="tab"
            aria-selected={active}
            data-testid={`${testId}-${p.id}`}
            onClick={() => onChange(p.id)}
            className={`h-7 px-3 rounded-md text-[12px] font-semibold transition-colors ${
              active
                ? 'bg-white text-[#4F46E5] shadow-sm'
                : 'text-[#6B6C85] hover:text-[#1A1B2E]'
            }`}
          >
            {p.label}
          </button>
        );
      })}
    </div>
  );
}

PeriodFilter.PERIODS = PERIODS;
